import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PointsEarnedModal from "../PointsEarnedModal";
import challengeClaimedGif from "../../../assets/images/gifs/challenge-claimed.gif";
import { I18N_NAMESPACES } from "../../../helpers/constants";
import { useDeviceSize } from "../../../helpers/hooks";
import URL_PATTERNS from "../../../urls";
import { colors } from "../../../styles/variables";
import { StyledDoneButton, StyledButton, StyledGhostButtonLink, ChallengesImage } from "./style";

interface ChallengeClaimedModalProps {
  onCancel: Function;
  challengeRewardPoints: number;
  challengeTitle: string;
}

const ChallengeClaimedModal = ({
  onCancel,
  challengeRewardPoints,
  challengeTitle,
}: ChallengeClaimedModalProps) => {
  const { t } = useTranslation([
    I18N_NAMESPACES.COMMON,
    I18N_NAMESPACES.MY_DASHBOARD,
    I18N_NAMESPACES.MY_BADGES,
  ]);
  const { isSmall } = useDeviceSize();

  const title = t("myBadges:challengeClaimed.title", {
    count: challengeRewardPoints,
  });
  const challengeClaimedDescription = (
    <Trans
      i18nKey="myBadges:challengeClaimed.description"
      components={{ bold: <strong /> }}
      values={{ challengeTitle }}
    />
  );

  const exploreBadgesButton = (
    <StyledButton onClick={() => onCancel()}>{t("myBadges:challengeClaimed.exploreBadges")}</StyledButton>
  );

  const viewPointsAndRewardsButton = (
    <StyledGhostButtonLink to={URL_PATTERNS.MY_PROGRESS}>
      {t("myBadges:challengeClaimed.viewPointsAndRewards")}
    </StyledGhostButtonLink>
  );

  const doneButton = <StyledDoneButton onClick={() => onCancel()}>{t("common:done")}</StyledDoneButton>;

  const image = <ChallengesImage src={challengeClaimedGif} alt={"Challenge Completed"} />;
  const buttons = isSmall ? [doneButton] : [exploreBadgesButton, viewPointsAndRewardsButton];
  const textAlign = isSmall ? "center" : "left";

  return (
    <PointsEarnedModal
      onCancel={onCancel}
      imageComponent={image}
      textAlign={textAlign}
      backgroundColor={colors.warningSoft}
      title={title}
      description={challengeClaimedDescription}
      buttons={buttons}
      showConfetti={false}
    />
  );
};

export default ChallengeClaimedModal;
